import React from "react";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import InvalidUrl from "app/pages/partner/InvalidUrl";

const CalculationsRouteGuard = ({ children }) => {
  const { getAuthUser } = useJumboAuth();

  // Get auth data same way as AppLayout
  const authData = getAuthUser() || {};
  const { customer } = authData;

  // Try to get from localStorage as fallback
  let localUser = null;
  try {
    const localData = localStorage.getItem("user");
    if (localData) {
      localUser = JSON.parse(localData);
    }
  } catch (error) {
    console.error("Error parsing localStorage user:", error);
  }

  // Use customer from auth or fallback to localStorage
  const finalCustomer = customer || localUser?.customer;
  const customerId = finalCustomer?.customerId;

  // Allow access only for customerId === 1
  if (customerId !== 1) {
    return <InvalidUrl />;
  }

  // Render the protected content
  return children;
};

export default CalculationsRouteGuard;
